import { useMemo } from 'react';
import { CustomVizHookDropdownOptions } from 'apps/sigma2-ui/src/lib/custom-viz/types';

export const useBasicCopilotDeptToRolesMap = ({
  dropdownOptions,
}: {
  dropdownOptions: CustomVizHookDropdownOptions;
}): Record<string, string[]> => {
  return useMemo(() => {
    const fullMap = dropdownOptions.filter(
      (dropdownItem) => dropdownItem.dropdownId === 'dept_to_titles_map',
    );

    const map: Record<string, string[]> = {};

    for (const item of fullMap) {
      const dept = item.dropdownItemValue;
      const role = item.dropdownItemText;

      if (!map[dept]) {
        map[dept] = [];
      }

      map[dept].push(role);
    }

    return map;
  }, [dropdownOptions]);
};
